import React from "react";
import Container from "../../components/Layout/Container";
import HamlSnippet from "../../components/globals/HamlSnippet";

function AttrMapperPage({ match }) {
  return (
    <Container
      location={{
        locationName: "Attributes Mapper",
        locationUrl: match.url,
      }}
    >
      <HamlSnippet url="/front/options/attr_mapper" />
    </Container>
  );
}

export default AttrMapperPage;
